<template>
  <div class="uploadCard">
    <!-- 中间部分 -->
    <!-- 1.拍摄身份证正反面部分 -->
    <div class="main">
      <div class="title">请拍摄/上传您的二代身份证</div>
      <div class="small-title">
        <span>我确认所提供的</span>身份证影像是最新且有效的
      </div>
      <div class="tabOne">
        <div class="idCard">
          <div class="name">- 上传个人身份证拍照件或者扫描件 -</div>
          <div class="idcodeimg">
            <div class="codeleft">
              <nut-imagepicker
                width="null"
                height="null"
                @imgMsg="tupian"
                :max="1"
                :imgList.sync="imgList1"
              >
              </nut-imagepicker>
            </div>
            <div class="coderight">
              <nut-imagepicker
                width="null"
                height="null"
                @imgMsg="tupian2"
                :max="1"
                :imgList.sync="imgList2"
              >
              </nut-imagepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="huiBlock"></div>
      <!-- 上传身份证要求 -->
      <div class="cradAsk">
        <div class="cardAskTitle">上传身份证要求</div>
        <div class="cardAskPara">
          <div>大陆公民持有的本人有效二代身份证</div>
          <div>拍摄时确保身份证<span class="askRed">边框完整，字体清晰，亮度均匀</span></div>
        </div>
      </div>
      <!-- 图片示例 -->
      <div class="shili">
        <div class="cardImgShili"><img :src='zhengqueImg' alt=""></div>
      </div>
      <div class="point">
        * 由平安银行提供账户支持，保障交易资金安全
      </div>
      <!-- 下一步 -->
      <div class="next">下一步</div>
    </div> 
  </div>
</template>

<script>
import registerArguments from "../../components/RegisterArguments";
export default {
  data() {
    return {
      active: 0,
      status: true,
      //   身份证
      idCodez: null,
      idCodeb: null,
      imgCode: 2,
      imgList1: [
        {
          id: 1,
          src: require("../../assets/img/card/z.png"),
        },
      ],
      imgList2: [
        {
          id: 2,
          src: require("../../assets/img/card/f.png"),
        },
      ],
      zhengqueImg:require("../../assets/img/card/shili.png")
    };
  },
  components: {
    registerArguments: registerArguments,
  },
  methods: {
    // 返回上一层
    back() {
      this.$router.go(-1); //返回上一层
    },
    // 步骤条
    next() {
      if (this.active++ > 3) this.active = 0;
    },

    //连接摄像头
    connectCamera() {
      navigator.getMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMeddia ||
        navigator.msGetUserMedia;
      let that = this;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            video: true,
            audio: true,
          })
          .then(function (stream) {
            // console.log(stream);
            that.stream = stream;
            that.cameraState = true;
            that.stream =
              typeof stream.stop === "function"
                ? stream
                : stream.getTracks()[1];
            var smallVideo = $(".smallVideo")[0];
            var bigVideo = $(".bigVideo")[0];
            smallVideo.src = (window.URL || window.webkitURL).createObjectURL(
              stream
            );
            bigVideo.src = (window.URL || window.webkitURL).createObjectURL(
              stream
            );
            smallVideo.play();
            bigVideo.play();
          })
          .catch(function (err) {
            console.log(err);
          });
      }
      // 使用旧方法打开摄像头
      else if (navigator.getMedia) {
        navigator.getMedia(
          {
            video: true,
          },
          function (stream) {
            console.log(stream);
            that.stream = stream;
            that.cameraState = true;
            that.stream = stream.getTracks()[0];
            console.log(that.stream);
            var smallVideo = $(".smallVideo")[0];
            var bigVideo = $(".bigVideo")[0];
            smallVideo.src = (window.URL || window.webkitURL).createObjectURL(
              stream
            );
            bigVideo.src = (window.URL || window.webkitURL).createObjectURL(
              stream
            );
            smallVideo.play();
            bigVideo.play();
          },
          function (err) {
            console.log(err);
          }
        );
      }
    },

    //关闭摄像头
    closeCamera() {
      this.cameraState = false;
      this.stream && this.stream.stop();
    },

    //点击拍摄或集鸽拍摄
    reCamera(foot_ring_sn) {
      console.log("拍照调用");
      var smallCanvas = $(".smallCanvas")[0];
      var smallContext = smallCanvas.getContext("2d");
      let smallVideo = $(".smallVideo")[0];
      smallContext.drawImage(smallVideo, 0, 0, 270, 200);
      //拍好的图片显示
      //smallCanvas.toDataURL('image/png').split(",")[1]
    },
    //
    nextStep() {
      console.log(this.bank_mobiled, "1111111111111111");
      if (this.methodIdentity != "") {
        this.idNumber = this.methodIdentity;
      }
      if (this.imgCode == 3) {
        if (!this.idcardIsImged) {
          this.$toast.warn("请上传身份证人像面");
          return;
        }
      }

      if (!this.idcardIsImg) {
        this.$toast.warn("请上传身份证人像面");
        return;
      }

      if (!this.idcardTheImg) {
        this.$toast.warn("请上传身份证国徽面");
        return;
      }

      if (!this.methodName) {
        this.$toast.warn("请填写姓名");
        return;
      }

      if (!this.idNumber) {
        this.$toast.warn("请填写身份证号码");
        return;
      }

      if (!this.bankCardNumber) {
        this.$toast.warn("请填写银行卡号");
        return;
      }

      if (!this.cellphoneNumber) {
        this.$toast.warn("请填写银行预留手机号");
        return;
      }
      if (!this.agreeArguments) {
        this.$toast.warn("请勾选协议");
        return;
      }
      if (sessionStorage.getItem("esignappsid")) {
        if (this.methodIdentityUpdate != "") {
          if (this.methodIdentityUpdate != this.idNumber) {
            this.$toast.warn("信息不一致");
            return;
          }
        }
      }
      //  console.log(this.bank_mobiled,'5555')
      // if (this.bank_mobiled != null || this.bank_noed != null) {
      //   // console.log(this.bank_mobiled,'6666666')
      //   if (
      //     this.bank_mobiled == this.cellphoneNumber &&
      //     this.bank_noed == this.bankCardNumber
      //   ) {
      //     const url = "/transferList";
      //     this.$router.push({ path: url });
      //     return;
      //   }
      // }
      http.post(config.saveAuthInfo, {
          idNoFront: this.idcardIsImg,
          idNoBack: this.idcardTheImg,
          idNo: this.idNumber,
          userName: this.methodName,
          bankNo: this.bankCardNumber,
          mobile: this.cellphoneNumber,
        })
        .then((e) => {
          if (e.code == 0) {
            const url = "/transferList";
            this.$router.push({ path: url });
          } else {
            this.$toast.warn(e.message);
          }
        });
    },
    //正面拍照
    tupian(e) {
      this.imgCode = e.code;
      if (this.imgCode == 3) {
        this.idcardIsImged == null;
      }
      if (this.imgCode == 3) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
      let tempFilePaths = e.msg[0];
      let that = this;
      that.idCardType = "front";
      this.uploadFile(tempFilePaths, function (data) {
        if (data) {
          that.methodIdentity = "";
          that.idNumber = "";
          that.idcardIsImg = data.uploadUrl;
          that.disabled = false;
          that.methodName = data.front.name;
          if (data.front.idNo) {
            var idNo = data.front.idNo;
            that.idNumber = data.front.idNo;
            that.methodIdentity = data.front.idNo;
          }
        }
      });
    },
    //反面拍照
    tupian2(e) {
      this.imgCode = e.code;
      if (e.code == 3) {
        this.idcardTheImg = null;
      }
      let tempFilePaths = e.msg[0];
      let that = this;
      that.idCardType = "back";
      this.uploadFile(tempFilePaths, function (data) {
        if (data) {
          that.disabled = false;
          that.idcardTheImg = data.uploadUrl;
        }
      });
    },

    uploadFile(filePaths, cb) {
      if (this.imgCode != 3) {
        this.disabled = true;
        this.$toast.text("准备上传");
        var fd = new FormData();
        //文件必须声明在最后，否则异常
        fd.append("file", filePaths);
        fd.append("idCardSide", this.idCardType);
        // console.log(fd.get("file"), "判断是否传进去"); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
        let configed = {
          headers: { "Content-Type": "multipart/form-data" },
        }; //添加请求头
        this.$http.post(config.idCardOcr, fd, configed).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.code == 200) {
              this.$toast.text("上传成功");
              this.disabled = false;
              var chars = res.data.data;
              // var result = chars.substring(chars.indexOf('https://gsb-zc.oss-cn-beijing.aliyuncs.com'), chars.indexOf('</Location>'));
              cb(chars);
            } else {
              this.disabled = true;
              this.$toast.warn(res.data.data.msg);
            }
          }
        });
      }
    },
  },
};
</script>
<style>
/* .el-steps--horizontal {
  padding-left: 50px;
  padding-right: 50px;
  margin-top: 80px;
}
.el-step__icon.is-text {
  border: none;
  font-size: 24px;
  width: 30px;
  height: 30px;
  margin-top: -5px;
}
.el-step__title.is-process {
  color: #fff;
}
.el-step__icon-inner {
  color: #0681fd;
} */
</style>
<style lang="less" scoped>
.uploadCard {
  width: 750px;
  height: 100%;
  .flex-row {
    display: flex;
    flex-direction: row;
  }
  //   头部
  .header {
    height: 285px;
    background-color: #0681fd;
    .outer2 {
      z-index: auto;
      .label2 {
        z-index: 32;
        width: 16px;
        height: 27px;
        margin-top: 10px;
        padding-left: 45px;
      }

      .word3 {
        z-index: 31;
        width: 200px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 32px;
        font-family: PingFangSC-Medium;
        line-height: 45px;
        text-align: center;
        margin-left: 30%;
      }
    }
  }
  //   中间部分
  .main {
    .title {
      margin-top: 30px;
      margin-left: 30px;
      text-align: left;
      font-size: 32px;
      color: #222222;
    }
    .small-title {
      margin-left: 30px;
      text-align: left;
      margin-top: 21px;
      color: #ff0000;
      font-size: 24px;
      span {
        color: #999999;
      }
    }
  }
  //   身份证
  .tabOne {
    position: relative;
    width: 100%;
    height: 100%;
    .idCard {
      width: 692px;
      height: 323px;
      margin: 0 auto;
      margin-top: 30px;
      background-color: #fff;
      padding: 40px;
      box-sizing: border-box;
      border-radius: 20px;
      .name {
        width: 100%;
        text-align: center;
        font-size: 30px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .idcodeimg {
        width: 561px;
        margin: 0 auto;
        margin-top: 27px;
        overflow: hidden;
        .codeleft {
          float: left;
          width: 267px;
          height: 167px;
          border-radius: 10px;
          border: 1px solid rgba(33, 170, 255, 1);
        }
        .coderight {
          float: right;
          width: 267px;
          height: 167px;
          border-radius: 10px;
          border: 1px solid rgba(33, 170, 255, 1);
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .main {
      width: 692px;
      margin: 0 auto;
      margin-top: 30px;
      border-radius: 20px;
      padding: 35px;
      padding-bottom: 0px;
      box-sizing: border-box;
      background-color: #fff;
      .tip {
        font-size: 26px;
        padding: 10px 0px 0px 20px;
        color: red;
      }
      .name {
        font-size: 30px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .items {
        width: 525px;
        margin: 30px auto;
        display: flex;
        font-size: 22px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        div {
          flex: 1;
          text-align: center;
          img {
            width: 113px;
            height: 90px;
            margin-bottom: 20px;
            // border: 1px solid #ccc;
          }
          div {
            display: flex;
            align-items: center;
            justify-content: center;
            i {
              margin-right: 10px;
            }
          }
        }
      }

      .arguments {
        color: #a2a2a2;
        font-size: 1.08em;
        text-align: center;
        padding: 20px;
        border-top: 1px solid rgba(219, 219, 219, 1);
        .input_check {
          vertical-align: middle;
        }
        a {
          color: #3083ff;
        }
      }
      .main-input {
        width: 100%;
        height: 87px;
        line-height: 87px;
        border-top: 1px solid rgba(219, 219, 219, 1);
        font-size: 28px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        padding-top: 5px;
        a {
          color: #3083ff;
        }
      }
    }
  }
  .huiBlock{
    width: 100%;
    height: 10px;
    background: #F8F8F8;
    }
  .cradAsk{
    text-align: left;
    padding-left: 30px;
    margin-top: 30px;
    .cardAskTitle{
      font-size: 32px;
      color: #222222;
      margin-bottom: 20px;
      }
    .cardAskPara{
      font-size: 24px;
      color: #999999;
      .askRed{color: #FF0000;}
      }
    }
    .shili{
      margin-top: 45px;
      padding: 20px 30px;   
      .cardImgShili img{
      width: 100%;
      height: auto;
    }  
    }  
    .point{
      width: 100%;
      height: 100px;
      line-height: 100px;
      background: #f8f8f8;
      text-align: left;
      padding: 0 30px;
      box-sizing: border-box;
      color: #999999;
    }
    .next{width: 100%;height: 90px;background: #0681FD;line-height: 90px;text-align: center;color: #fff;font-size: 18px;}
}
</style>


// WEBPACK FOOTER //
// src/pages/uploadCard/index.vue